"use client";
import Image from "next/image";
import * as images from "@/components/images/Images";
import { Button } from "@/components/ui/button";
import { usePathname } from "next/navigation";
import Link from "next/link";
import { cn } from "@/lib/utils";
import { memo, useState } from "react";
import Icon from "@/components/ui/Icon";
import { ROUTES } from "@/constants";
import FooterCTAImage from "./FooterCTAImage";

export type FooterCTAProps = {} & React.ComponentProps<"div">;

const FooterCTA = ({ className }: FooterCTAProps) => {
  const pathname = usePathname();
  const isPricingPage =
    pathname === "/pricing" ||
    pathname.startsWith("/languages") ||
    pathname.startsWith("/documents");

  return (
    <div className={cn("section", className)}>
      <div className="container py-12 flex justify-center lg:block lg:pt-96 relative mx-auto">
        <div
          className={cn(
            "rounded-3xl bg-[#2F80ED] relative z-25 py-12 px-8 lg:absolute lg:-mt-[650px] lg:p-0 lg:rounded-2xl",
            isPricingPage ? "lg:h-[557px]" : "lg:h-[607px]"
          )}
        >
          <div
            className={cn(
              "grid grid-cols-1 md:grid-cols-2 md:gap-4 lg:gap-0",
              isPricingPage ? "lg:mt-10" : "-lg:mt-10"
            )}
          >
            <div className="flex flex-col gap-2 lg:gap-5 lg:items-start justify-center lg:pl-20">
              <span className="text-[2rem] leading-[120%] font-semibold lg:text-[55px] lg:font-medium">
                Get your <br /> translation right!
              </span>

              <div className="flex flex-col gap-3 text-base leading-[135%] lg:text-2xl lg:font-medium lg:leading-[150%] lg:order-3">
                <span>Do you have a complex or unique project?</span>
                <Link
                  href={ROUTES.getQuote}
                  className="inline-flex items-center text-lg font-semibold underline lg:text-2xl"
                >
                  Get a quote
                  <Icon
                    id="icon-arrow-right-lg_24"
                    width={24}
                    height={24}
                    className="shrink-0 ml-2 lg:hidden"
                  />
                </Link>
              </div>

              <Button
                variant="outline"
                className="mt-5 rounded-3xl lg:rounded-full border-[#2F80ED] text-[#2F80ED] font-semibold text-base hover:bg-white hover:text-[#2F80ED] h-[48px] lg:h-[84px] md:w-[312px] lg:text-2xl lg:mt-0"
                asChild
              >
                <Link href={ROUTES.startOrder}>Start order</Link>
              </Button>
            </div>

            <div className="mt-4.5 flex justify-center items-center lg:mt-0">
              <FooterCTAImage isPricingPage={isPricingPage} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default memo(FooterCTA);
